var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("bo-base-layout bo-base-layout--" + _vm.logoTheme)]},[_c('div',{class:[
      'bo-base-layout__left',
      {
        '--has-left-component': true,
        '--hide-on-mobile': _vm.hideIlustraOnMobile
      }
    ]},[_c('router-link',{class:("bo-base-layout__logo bo-base-layout__logo--mobile --" + _vm.logoTheme),attrs:{"to":"/"}},[_c('TwismLogoIcon',{attrs:{"width":"82.5","height":"20"}})],1),_vm._t("left-component")],2),_c('header',{class:[
      'bo-base-layout__header',
      { 'bo-base-layout__header--hide-navlinks': !_vm.showNavLinks }
    ]},[_c('div',{staticClass:"bo-base-layout__header-left"},[_c('router-link',{class:("bo-base-layout__logo --" + _vm.logoTheme),attrs:{"to":"/"}},[_c('TwismLogoIcon',{attrs:{"width":"124.57","height":"28"}})],1)],1)]),_c('div',{staticClass:"bo-base-layout__right",class:{ '--not-scroll': !_vm.scrollRightCol }},[_vm._t("right-component")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }